window.ajaxSubmitForm = function($form, success, error){
    $.ajax({
        url: $form.attr('action'),
        type: 'post',
        data: new FormData($form[0]),
        contentType: false,
        processData: false,
        dataType: 'json',
        statusCode: {
            200: (res) => success(res, $form),
            300: (res) => window.location.assign(res.responseJSON.url),
            400: (res) => error(res, $form)
        }
    });
};